'use strict'

import angular from 'angular';

angular.module('errorsHandler.services', []).factory('ErrorsHandler', ErrorsHandler)

/**
 * @ngInject
 */
function ErrorsHandler($ioAlert, ModalService) {
    let handlers = {
        400() {
            showError('The request submitted to the server was malformed.')
        },
        404() {
            showError('The requested resource was not found.')
        },
        422(response) {
            if (response.data.isSimple) {
                showError(response.data.message)
                return;
            }
            ModalService.openUnprocessableEntityModal(response.data.errors)
        },
        500() {
            showError('Something went wrong here. Please refresh the page to try again')
        }
    }

    function showError(message) {
        $ioAlert.show('Error!', message, 'error')
    }

    return {
        handle(response) {
            let handle = handlers[response.status] ? handlers[response.status] : handlers[500];
            handle(response);
        }
    }
}